import React, { useState, useEffect } from 'react';
import { generatePDF } from '../utils/pdfGenerator';
import { t } from '../utils/translations';
import './PDFPreview.css';

const PDFPreview = ({ proposalData, onConfirm, onCancel }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isGenerating, setIsGenerating] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const generatePreview = async () => {
      try {
        setIsGenerating(true);
        const pdfBlob = await generatePDF(proposalData);
        const url = URL.createObjectURL(pdfBlob);
        setPdfUrl(url);
        setIsGenerating(false);
      } catch (err) {
        setError(err.message || 'Failed to generate PDF preview');
        setIsGenerating(false);
        console.error('PDF generation error:', err);
      }
    };

    generatePreview();

    // Cleanup: revoke object URL when component unmounts
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [proposalData]);

  const handleConfirm = async () => {
    if (pdfUrl) {
      // Generate fresh PDF for sending
      try {
        const pdfBlob = await generatePDF(proposalData);
        await onConfirm(pdfBlob);
      } catch (err) {
        setError(err.message || 'Failed to generate PDF for sending');
      }
    }
  };

  if (isGenerating) {
    return (
      <div className="pdf-preview-overlay">
        <div className="pdf-preview-container">
          <div className="pdf-preview-loading">
            <div className="spinner"></div>
            <p>{t('preparingPreview')}</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pdf-preview-overlay">
        <div className="pdf-preview-container">
          <div className="pdf-preview-error">
            <h2>Error Generating Preview</h2>
            <p>{error}</p>
            <button onClick={onCancel} className="btn-cancel">
              Go Back
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pdf-preview-overlay">
      <div className="pdf-preview-container">
        <div className="pdf-preview-header">
          <h2>{t('previewSendProposal')}</h2>
          <p>{t('proposalSentMessage')}</p>
        </div>
        
        <div className="pdf-preview-content">
          {pdfUrl && (
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              className="pdf-preview-iframe"
            />
          )}
        </div>

        <div className="pdf-preview-actions">
          <button onClick={onCancel} className="btn-cancel">
            {t('cancel')}
          </button>
          <button onClick={handleConfirm} className="btn-confirm">
            {t('confirmSendEmail')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PDFPreview;
